export interface TemplateFormat {
  name: string;
  width: number;
  height: number;
  recommendedUses: string[];
  guideText: string;
  portraitRecommended: boolean;
}

export const BRANCH_TEMPLATE_FORMATS: TemplateFormat[] = [
  {
    name: 'Kvadratisk',
    width: 1080,
    height: 1080,
    recommendedUses: ['Facebook feed', 'Instagram feed'],
    guideText: '',
    portraitRecommended: false,
  },
  {
    name: 'Portræt',
    width: 720,
    height: 1280,
    recommendedUses: [
      'Instagram story',
      'TikTok',
      'Instagram portræt',
      'Twitter portræt',
    ],
    guideText:
      'Hvis du også skal bruge videoen i landskab, så vil dette format ofte blive beskåret. Vi anbefaler at du optager i landskab, hvis du skal bruge videoen i begge formater.',
    portraitRecommended: true,
  },
  {
    name: 'Landskab',
    width: 1280,
    height: 720,
    recommendedUses: ['Facebook feed', 'Instagram feed'],
    guideText: '',
    portraitRecommended: false,
  },
  {
    name: 'Bredformat (HD)',
    width: 1920,
    height: 1080,
    recommendedUses: ['YouTube'],
    guideText: '',
    portraitRecommended: false,
  },
];
